import { DataTag, type DataTagProps } from '@/components/DataTag/DataTag'
import { routeToAccountManagementWithPrefilledEmail } from '@/features/AccountManagement/pages/AccountManagement'
import { getAuth0UserLink } from '@/features/HivesOverview/components/ExternalLinks'
import { useNavigate } from '@tanstack/react-router'

export function AccountLink({
  account,
}: Readonly<
  { account: string } & Omit<
    DataTagProps,
    'value' | 'externalLink' | 'onClickBody'
  >
>) {
  const navigate = useNavigate()

  if (!account?.trim()) {
    return <DataTag hasCopy={false} fontWeight={500} fontSize="1rem" />
  }

  const isEmail = account.includes('@')

  return (
    <DataTag
      value={account}
      fontWeight={500}
      fontSize="1rem"
      externalLink={isEmail ? undefined : getAuth0UserLink(account)}
      onClickBody={
        isEmail
          ? () => routeToAccountManagementWithPrefilledEmail(navigate, account)
          : undefined
      }
    >
      {account}
    </DataTag>
  )
}
